
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpiideoMappingForEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spiideoMappingForEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"event"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"home_competitor_has_mapping"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"away_competitor_has_mapping"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stadium_has_mapping"},"arguments":[],"directives":[]}]}}]}},{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetEventSpiideoScheduling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spiideoEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"event"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"game_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"live_production_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"live_output_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"low_latency_production_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"low_latency_output_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_shared"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pending_operation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lifecycle_state"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reconciliation_datetime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creation_datetime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"update_datetime"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"spiideoReconciliationAttempts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"event"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"outcome"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attempt_datetime"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":708}};
    doc.loc.source = {"body":"query SpiideoMappingForEvent($event: ID!) {\n    spiideoMappingForEvent(event: $event) {\n        home_competitor_has_mapping\n        away_competitor_has_mapping\n        stadium_has_mapping\n    }\n}\n\nquery GetEventSpiideoScheduling($eventId: ID!) {\n    spiideoEvent(event: $eventId) {\n        id\n        game_id\n        live_production_id\n        live_output_id\n        low_latency_production_id\n        low_latency_output_id\n        is_shared\n        pending_operation\n        lifecycle_state\n        reconciliation_datetime\n        creation_datetime\n        update_datetime\n    }\n    spiideoReconciliationAttempts(event: $eventId) {\n        id\n        outcome\n        message\n        attempt_datetime\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SpiideoMappingForEvent"] = oneQuery(doc, "SpiideoMappingForEvent");
        
        module.exports["GetEventSpiideoScheduling"] = oneQuery(doc, "GetEventSpiideoScheduling");
        
